import api from "./api.service";
import midiaService from "./midia.service";

export interface OrganizationData {
  organizationUuid: string;
  organizationName?: string;
  organizationTaxPayerID?: string;
  organizationEmail?: string;
  organizationPhone?: string;
  organizationAddress?: string;
  organizationDescription?: string;
  organizationLogoUrl?: string;
  organizationStatus?: boolean;
}

class OrganizationClass {
  async updateOrganization(data: Partial<OrganizationData>) {
    const response = await api.patch(
      `/organization/${data.organizationUuid}`,
      data,
    );
    return response.data;
  }

  async updateOrganizationLogo(
    imageFile: File,
    organization: OrganizationData,
  ): Promise<{ token: string }> {
    let imageUrl: string;

    imageUrl = await midiaService.enviar(imageFile, "organizacao");

    // Envia a URL para o backend
    const response = await api.patch(
      `/organization/${organization.organizationUuid}`,
      {
        ...organization,
        organizationLogoUrl: imageUrl,
      },
    );

    return response.data;
  }

  async getOrganization(organizationUuid: string) {
    const response = await api.get(`/organization/${organizationUuid}`);
    return response.data;
  }

  async getOrganizationStats(organizationUuid: string) {
    const response = await api.get(`/organization/${organizationUuid}/stats`);
    return response.data;
  }
}

export const organizationService = new OrganizationClass();
